import { render } from "./ConsentBody.vue?vue&type=template&id=287a3636&scoped=true"
import script from "./ConsentBody.vue?vue&type=script&lang=js"
export * from "./ConsentBody.vue?vue&type=script&lang=js"

import "./ConsentBody.vue?vue&type=style&index=0&id=287a3636&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287a3636"]])

export default __exports__